import { render, staticRenderFns } from "./MarketAnswerEvent.vue?vue&type=template&id=7b4c3481&scoped=true&"
import script from "./MarketAnswerEvent.vue?vue&type=script&lang=js&"
export * from "./MarketAnswerEvent.vue?vue&type=script&lang=js&"
import style0 from "./MarketAnswerEvent.vue?vue&type=style&index=0&id=7b4c3481&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4c3481",
  null
  
)

export default component.exports